import { mapGetters } from "vuex"

const handles_projects = {
    methods: {
        post_load (response) {
            this.versions = []
            if(response && response.meta && response.meta.versions) this.versions = response.meta.versions
            this.project_ids = (!!response && !!response.meta && !!response.meta.updates && !!response.meta.updates.project) ? response.meta.updates.project.map(project => project.id) : []
        },
        project_filter_evaluation (project, filter) {
            if(!project) return false
            if(!filter) return true

            if(filter === "pic") return project.pic_id === this.state.user_id
            if(filter === "pm") return project.pm_id === this.state.user_id
            if(filter === "d") return (project.pic_id !== this.state.user_id) && (project.pm_id !== this.state.user_id)
            if(filter === "starred") return !!project.favorite

            return false
        },
        has_filtered_projects (filter) {
            if(!this.report || !this.project_ids.length) return false
            return !!this.projects.find(project => this.project_filter_evaluation(project, filter))
        }
    },
    computed: {
        ...mapGetters(["entity_records"]),
        fields () {
            return ["ns::project;fieldset::graph"]
        },
        projects () {
            return this.entity_records("project", this.project_ids)
        },
        filtered_data () {
            if(!this.report || !this.project_ids.length) return []

            if(!this.state.filter) return this.projects

            return this.projects.filter(project => this.project_filter_evaluation(project, this.state.filter))
        }
    },
    data () {
        return {
            project_ids: []
        }
    }
}

export default handles_projects
